import { SxProps, Theme } from '@mui/material'
// TODO @degzhaus - this feels wrong, but making sxc a custom hook also feels wrong
import { C1Theme as theme } from 'c1ui'

export type moduleStyleType = Record<string, SxProps<Theme>>

export type sxcBool = [boolean | undefined, SxProps<Theme> | undefined] | SxProps<Theme> | undefined

// sxc = sx-combine
export const sxc = (...items: sxcBool[]): SxProps<Theme> => {
    const rv: SxProps<Theme> = {}
    Object.assign(
        rv,
        ...items
            .filter((sxPair: sxcBool): boolean => {
                if (Array.isArray(sxPair)) {
                    return sxPair[0] === true && sxPair[1] !== undefined
                }
                return sxPair !== undefined
            })
            .map((sxPair: sxcBool): SxProps<Theme> => {
                // filter above removes any undefined pairs
                if (typeof sxPair === 'function') {
                    return sxPair(theme)
                } if (Array.isArray(sxPair)) {
                    return sxPair[1] as SxProps<Theme>
                }
                return sxPair as SxProps<Theme>
            }),
    )
    return rv
}
